import(/* webpackMode: "eager" */ "/codebuild/output/src1005460018/src/mb-website/src/app/privacy-policy/page.js")